import { render, staticRenderFns } from "./request-application-details-step.vue?vue&type=template&id=13a5e228"
import script from "./request-application-details-step.vue?vue&type=script&lang=js"
export * from "./request-application-details-step.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports